import AssetField from '../../../contentful/AssetField';
import FileAssetField from '../../../contentful/FileAssetField';
import AssetCollectionField from '../../../contentful/AssetCollectionField';
import BlockEditor from '../../../block-editor/Editor';
import ColorList from './ColorList';
import ModelPagesList from './ModelPagesList';
import EquipmentList from './EquipmentList';
import EquipmentFactoryList from './EquipmentFactoryList';
import cookie from 'js-cookie';
import EquipmentLevelList from './EquipmentLevelList';
import FileAssetCollectionField from '../../../contentful/FileAssetCollectionField';
import {NavLink as Link} from 'react-router-dom';
import Loading from './../misc/Loading';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import update from 'immutability-helper';
import VariantGroupList from './VariantGroupList';
import React from 'react';
import TagsInput from 'react-tagsinput';
import Entity from '../../../contentful/Entity';


// Style
import 'react-tagsinput/react-tagsinput.css';
import slug from 'slug';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

function tooltip(text) {
  const tooltip = (
    <Tooltip>
      {text}
    </Tooltip>
  );

  return tooltip;
}

class Model extends React.Component {
  constructor(props) {
    super(props);

    this.allowedCategories = [
      'Personbil',
      'Varebil',
      'Elbil',
      'Ladbar hybrid',
      'Hybrid',
      'Plug-in Hybrid'
    ];

    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.setTabCookie = this.setTabCookie.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.checkAllowedCategories = this.checkAllowedCategories.bind(this);
    this.handleColors = this.handleColors.bind(this);
    this.handleEQFChange = this.handleEQFChange.bind(this);
    this.handlePageCreate = this.handlePageCreate.bind(this);
  }

  componentDidMount() {
    const tab = cookie.get('mgModelTab');
    if (tab !== '' && tab !== undefined && document.getElementById(tab)) {
      const tabLink = document.getElementById(tab);
      tabLink.click();
    }
  }

  handleAssetChange(name, asset) {
    const change = {
      model: {}
    };

    change.model[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleFieldChange(e) {
    const newData = {
      model: {}
    };

    if (e.target.type === 'checkbox') {
      newData.model[e.target.name] = {
        $set: e.target.checked
      };
    } else {
      newData.model[e.target.name] = {
        $set: e.target.value
      };
    }

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  checkAllowedCategories(tag) {
    return (this.allowedCategories.indexOf(tag) >= 0);
  }

  handleCategoryChange(tagsArray) {
    tagsArray = tagsArray.filter(this.checkAllowedCategories);

    const newData = {
      model: {}
    };

    newData.model.category = {
      $set: tagsArray
    };

    const props = update(this.props, newData);
    this.props.onChange(props);
  }

  handleEQFChange(orderedEquipmentFactoryList) {
    const orderedIds = orderedEquipmentFactoryList.map((eqf) => eqf.id);

    const newData = {
      model: {}
    };

    newData.model.equipmentFactoryOrderList = {
      $set: orderedIds
    };


    // TODO: WHY DO I HAVE TO DO THIS????
    // For some reason we need to clear the equipmentFactory before setting the new one
    // so that sort works on the updated list...
    newData.equipmentFactory = {
      $set: []
    };

    const props = update(this.props, newData);
    this.props.onChange(props);

    // Set the updated list ...
    newData.equipmentFactory = {
      $set: orderedEquipmentFactoryList
    };

    const propsAgain = update(this.props, newData);
    this.props.onChange(propsAgain);
  }

  handlePageCreate(e) {
    e.preventDefault();
    this.props.onPageCreate();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleColors(colorObj, modelId) {
    this.props.onColorChange(colorObj, modelId);
  }

  setTabCookie(e) {
    const tabLink = e.target.id;
    const cookieName = 'mgModelTab';

    cookie.set(cookieName, tabLink, {path: '/'});
  }

  render() {
    if (this.props.model) {
      const model = this.props.model;

      const makeName = this.props.make.name;
      const displayname = (model.displayname ? model.displayname : model.name);
      const predefinedTags = [makeName, displayname];

      return (
        <section className="mf-model mf-padding-top-20">
          <ol className="breadcrumb">
            <li><Link to="/">Forsiden</Link></li>
            <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li>
            <li>
              <Link to={`/modeller/${this.props.make.id}`}>{makeName}</Link>
            </li>
            <li className="active">{displayname}</li>
          </ol>

          <form onSubmit={this.handleSubmit}>
            <div className="page-header">
              <div className="pull-right">
                {this.props.working &&
                  <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                <button
                  type="submit"
                  className="btn btn-default"
                  disabled={!this.props.modified || this.props.working}
                >
                  <span>Lagre endringer</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={this.props.model.archived || (this.props.model.published && !this.props.model.updated) || this.props.working || this.props.modified}
                  onClick={this.handlePublish}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={this.props.model.draft || this.props.working || this.props.modified}
                  onClick={this.handleUnpublish}
                >
                  <span>Avpubliser</span>
                </button>
                &nbsp;
                {!this.props.model.archived && !this.props.model.published &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={(this.props.working)}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onArchive();
                    }}
                  >
                    <span>Arkiver</span>
                  </button>
                }
                {this.props.model.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={(this.props.working)}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onUnArchive();
                    }}
                  >
                    <span>Gjenopprett</span>
                  </button>
                }
              </div>
              <h1>
                {makeName} <em>{displayname}</em> <PublishStatusDot entry={this.props.model} />
              </h1>
              {!model.id &&
                <div className="help-block">
                  Modellen må lagres en gang før du kan gjøre alle endringer
                </div>
              }
            </div>

            {/* Display any error message: */}
            {this.props.error &&
              <div className="alert alert-danger">
                {this.props.error}
              </div>
            }

            {/* Tabs */}
            {model.id &&
              <ul className="nav nav-tabs" role="tablist">
                <li role="presentation" className="active"><a href="#general" id="generalTab" data-target="#general" aria-controls="general" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Generelt</a></li>
                {makeName === 'Hongqi' && <li role="presentation"><a href="#pages" id="pagesTab" data-target="#pages" aria-controls="pages" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Undersider</a></li>}
                <li role="presentation"><a href="#images" id="imagesTab" data-target="#images" aria-controls="images" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Bilder</a></li>
                <li role="presentation"><a href="#imagegalleries" id="galleriesTab" data-target="#imagegalleries" aria-controls="imagegalleries" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Bildegallerier</a></li>
                <li role="presentation"><a href="#files" id="filesTab" data-target="#files" aria-controls="files" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Filer</a></li>
                <li role="presentation"><a href="#equipmentlevels" id="equipmentTab" data-target="#equipmentlevels" aria-controls="equipmentlevels" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Utstyrsnivåer</a></li>
                <li role="presentation"><a href="#variants" id="variantsTab" data-target="#variants" aria-controls="variants" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Varianter</a></li>
                <li role="presentation"><a href="#colors" id="colorsTab" data-target="#colors" aria-controls="colors" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Farger</a></li>
                <li role="presentation"><a href="#equipments" id="equipmentsTab" data-target="#equipments" aria-controls="equipments" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Tilbehør</a></li>
                {(makeName === 'Renault' || makeName === 'Dacia') &&
                  <li role="presentation"><a href="#equipmentFactory" id="equipmentFactoryTab" data-target="#equipmentFactory" aria-controls="equipmentFactory" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Ekstrautstyr</a></li>
                }
                {(makeName === 'Hongqi') &&
                  <li role="presentation"><a href="#equipmentFactory" id="equipmentFactoryTab" data-target="#equipmentFactory" aria-controls="equipmentFactory" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Interiør</a></li>
                }
                <li role="presentation"><a href="#configurator" id="configuratorTab" data-target="#configurator" aria-controls="configurator" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Konfigurator</a></li>
                <li role="presentation"><a href="#metadata" id="metadataTab" data-target="#metadata" aria-controls="metadata" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Metadata</a></li>
              </ul>
            }

            {!model.id &&
              <ul className="nav nav-tabs" role="tablist">
                <li role="presentation" className="active"><a href="#general" id="generalTab" data-target="#general" aria-controls="general" role="tab" data-toggle="tab" onClick={this.setTabCookie}>Generelt</a></li>
              </ul>
            }

            {/* Tab content */}
            <div className="tab-content mf-margin-bottom-40">

              {/* GENERAL */}
              <div role="tabpanel" className="tab-pane active" id="general">
                <div className="row">
                  <div className="col-xs-12 col-md-6">

                    {!model.custom && <div className="form-group">
                      <label>Visningsnavn</label>
                      <input type="text" className="form-control" name="displayname" value={model.displayname} onChange={this.handleFieldChange} />
                    </div>}

                    {model.custom && <div className="form-group">
                      <label>Visningsnavn</label>
                      <input type="text" className="form-control" name="name" value={model.name} onChange={this.handleFieldChange} />
                    </div>}

                    <div className="form-group">
                      <label>Beskrivelse (kort)</label>
                      <textarea
                        className="form-control"
                        name="shortDescription"
                        rows="4"
                        value={model.shortDescription}
                        onChange={this.handleFieldChange}
                        disabled={this.props.working}
                      />
                    </div>

                    {makeName === 'Hongqi' && <div className="form-group">
                      <label>Topptekst</label>
                      <input type="text" className="form-control" name="intro" value={model.intro} onChange={this.handleFieldChange} />
                    </div>}

                    {makeName === 'Hongqi' && <div className="form-group">
                      <label>Topptekst farge</label>
                      <select
                        className="form-control"
                        defaultValue={model.introColor}
                        name="introColor"
                        disabled={this.props.working}
                        onChange={this.handleFieldChange}
                      >
                        <option value="">Svart tekst</option>
                        <option value="white">Hvit tekst</option>
                      </select>
                    </div>}
                  </div>

                  <div className="col-xs-12 col-md-6">

                    <div className="form-group">
                      <label>Biltype</label>
                      <div>
                        <TagsInput
                          addOnBlur={true}
                          value={model.category}
                          onChange={this.handleCategoryChange}
                          className="react-tagsinput form-control"
                          addKeys={[9, 13, 188]}
                          inputProps={{placeholder: 'Legg til'}}
                        />
                      </div>
                      <small>Mulige valg:&nbsp;
                        {this.allowedCategories.map((category, i) => {
                          const max = this.allowedCategories.length;
                          let suffix = ', ';
                          if ((max - 1) === i) {
                            suffix = '';
                          }
                          return (
                            <span key={i}>
                              {category}{suffix}
                            </span>
                          );
                        })}
                      </small>

                    </div>

                    {!model.custom && <div className="form-group">
                      <label>Navn</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="name" value={model.name} disabled />
                        <div className="input-group-addon">Data fra Axapta</div>
                      </div>
                    </div>}

                    <div className="form-group">
                      <label>URL</label>
                      <OverlayTrigger placement="top" overlay={tooltip('Hvis URL ikke er angitt så vil modellnavnet brukes som URL. Endring er kun tillatt med status "Ikke publisert"')}>
                        <span className="fa fa-question text-info" aria-hidden="true"></span>
                      </OverlayTrigger>
                      <input type="text" className="form-control" name="url" value={model.url} placeholder={slug(model.name)} onChange={this.handleFieldChange} disabled={model.published || model.working} />
                    </div>

                    {!model.custom && <div className="form-group">
                      <label>Modellgruppe</label>
                      <div className="input-group">
                        <input type="text" className="form-control" name="modelGroup" value={model.modelGroup} onChange={this.handleFieldChange} disabled={!model.custom || this.props.working} />
                        <div className="input-group-addon">{model.custom ? '' : 'Data fra Axapta'}</div>
                      </div>
                    </div>}


                    <div className="form-group">
                      <label>Visning</label>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="disableTestdrive" defaultChecked={model.disableTestdrive} onChange={this.handleFieldChange} disabled={this.props.working} />
                          Deaktiver prøvekjøring
                        </label>
                      </div>
                      <div className="checkbox">
                        <label title="Skjul bilmoddelen fra oversikten, men tilgjengelig via URL">
                          <input type="checkbox" name="hiddenModel" defaultChecked={model.hiddenModel} onChange={this.handleFieldChange} disabled={this.props.working} />
                          Skjult bilmodell
                        </label>
                      </div>
                      <div className="checkbox">
                        <label title="Skjuler priser. Vil også deaktivere konfigurator">
                          <input type="checkbox" name="hidePrice" defaultChecked={model.hidePrice} onChange={this.handleFieldChange} disabled={this.props.working} />
                          Skjul priser
                        </label>
                      </div>
                      <div className="checkbox">
                        <label title="Fjerner konfiguratoren og lenker til siden">
                          <input type="checkbox" name="disableConfigurator" defaultChecked={model.disableConfigurator} onChange={this.handleFieldChange} disabled={model.hidePrice || this.props.working} />
                          Deaktiver konfigurator
                        </label>
                      </div>
                      <div className="checkbox">
                        <label title="Deaktiver videovisning dersom det er aktivert på forhandler">
                          <input type="checkbox" name="disableDigitalCarView" defaultChecked={model.disableDigitalCarView} onChange={this.handleFieldChange} disabled={model.hidePrice || this.props.working} />
                          Deaktiver videovisning
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {model.id && <div className="row">
                  <div className="col-xs-12">
                    <div className="form-group">
                      <label>Beskrivelse</label>
                      {model.description /*&& model.description.find((md) => !md.published || md.updated)*/ && <div className="hidden">
                        <ul>
                          {model.description.map((md) => <li key={md.id}>{md.id}: {((!md.published && 'Ikke publisert') || (md.updated && 'Endret') || (md.draft && 'Kladd') || 'Publisert')}</li>)}
                        </ul>
                      </div>}
                      <div>
                        <BlockEditor
                          blocks={model.description}
                          onChange={(blocks) => this.handleAssetChange('description', blocks)}
                          disabled={!model.id || this.props.working}
                          enableTwoColumns
                          enableModelContent
                          enableBlockAdjustments
                          allowVideo
                          predefinedTags={predefinedTags}
                        />
                      </div>
                    </div>
                  </div>
                </div>}
              </div>
              {/* // GENERAL */}

              {(makeName === 'Hongqi') &&
                <div role="tabpanel" className="tab-pane" id="pages">
                  <h3 className="pull-left">Undersider</h3>
                  <ModelPagesList
                    pages={model.pages}
                    onCreate={this.handlePageCreate}
                    modelModified={this.props.modified}
                    disabled={!model.id || this.props.working}
                  />
                </div>
              }

              {/* IMAGES */}
              <div role="tabpanel" className="tab-pane" id="images">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Hovedbilde</label>
                      <AssetField name="image" allowVideo={makeName === 'Hongqi'} value={model.image} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Listebilde</label>
                      <AssetField name="listImage" value={model.listImage} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                    </div>
                  </div>

                  <div className="clearfix"></div>

                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Silhuettbilde</label>
                      <AssetField name="silhouetteImage" value={model.silhouetteImage} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Modellogo</label>
                      <AssetField name="modelLogo" value={model.modelLogo} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                    </div>
                  </div>

                  <div className="clearfix"></div>

                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Brosjyrebilde</label>
                      <AssetField name="brochureImage" value={model.brochureImage} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                    </div>
                  </div>

                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Mobilbilde</label>
                      <AssetField name="mobileImage" allowVideo={makeName === 'Hongqi'} value={model.mobileImage} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                    </div>
                  </div>
                </div>
              </div>
              {/* // IMAGES */}

              {/* IMAGEGALLERIES */}
              <div role="tabpanel" className="tab-pane" id="imagegalleries">
                <div className="form-group">
                  <label>Bildegalleri (eksteriør)</label>
                  <AssetCollectionField name="imageGalleryExterior" value={model.imageGalleryExterior} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                </div>

                <div className="form-group">
                  <label>Bildegalleri (interiør)</label>
                  <AssetCollectionField name="imageGalleryInterior" value={model.imageGalleryInterior} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                </div>

                <div className="form-group">
                  <label>Bildegalleri (farger)</label>
                  <AssetCollectionField name="imageGalleryColor" value={model.imageGalleryColor} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                </div>
              </div>
              {/* // IMAGEGALLERIES */}

              {/* FILES */}
              <div role="tabpanel" className="tab-pane" id="files">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Brosjyrer</label>
                      <FileAssetCollectionField name="brochures" value={model.brochures} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={[...predefinedTags, 'Brosjyre']} />
                      <span className="help-block">
                        Det er mulig å knytte flere brosjyrer til modellen, men den øverste i
                        listen vil vises sammen med brosjyrebildet i en større visning enn
                        resten.
                      </span>
                    </div>
                  </div>

                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Prislister</label>
                      <FileAssetCollectionField name="priceLists" value={model.priceLists} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={[...predefinedTags, 'Prisliste']} />
                    </div>
                  </div>

                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Utstyr</label>
                      <FileAssetCollectionField name="equipmentLists" value={model.equipmentLists} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={[...predefinedTags, 'Utstyr']} />
                    </div>
                  </div>

                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <label>Energimerking dekk</label>
                      <FileAssetField name="tyreLabeling" value={model.tyreLabeling} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={[...predefinedTags, 'Energimerking dekk']} />
                    </div>
                  </div>
                </div>
              </div>
              {/* // FILES */}

              {/* EQUIPMENT LEVELS */}
              <div role="tabpanel" className="tab-pane" id="equipmentlevels">
                <h3 className="pull-left">Utstyrnivåer</h3>
                <EquipmentLevelList
                  equipmentLevels={this.props.equipmentLevels}
                  modelId={model.id}
                  modelModified={this.props.modified}
                />
              </div>
              {/* // EQUIPMENT LEVELS */}

              {/* VARIANTS */}
              <div role="tabpanel" className="tab-pane" id="variants">
                <h3 className="pull-left">Varianter</h3>
                <VariantGroupList
                  modelIsVarebil={model.category.includes('Varebil')}
                  modelIsElbil={model.category.includes('Elbil')}
                  modelId={model.id}
                  modelModified={this.props.modified}
                  variants={this.props.variants}
                  variantGroups={this.props.variantGroups}
                />
              </div>
              {/* // VARIANTS */}

              {/* COLORS */}
              <div role="tabpanel" className="tab-pane" id="colors">
                <h3 className="pull-left">Farger</h3>
                <ColorList
                  colors={this.props.colors}
                  modelId={model.id}
                  modelModified={this.props.modified}
                  onColorChange={this.handleColors}
                  working={this.props.working}
                />
              </div>
              {/* // COLORS */}

              {/* EQUIPMENT */}
              <div role="tabpanel" className="tab-pane" id="equipments">
                <h3 className="pull-left">Tilbehør</h3>
                <EquipmentList
                  equipments={this.props.equipments}
                  modelId={model.id}
                  modelModified={this.props.modified}
                  working={this.props.working}
                />
              </div>
              {/* // EQUIPMENT */}

              {/* EQUIMENT FACTORY */}
              {(makeName === 'Renault' || makeName === 'Dacia') &&
                <div role="tabpanel" className="tab-pane" id="equipmentFactory">
                  <h3 className="pull-left">Fabrikkmontert ekstrautstyr</h3>
                  <EquipmentFactoryList
                    equipmentFactory={this.props.equipmentFactory}
                    modelId={model.id}
                    modelModified={this.props.modified}
                    onChange={this.handleEQFChange}
                  />
                </div>
              }
              {(makeName === 'Hongqi') &&
                <div role="tabpanel" className="tab-pane" id="equipmentFactory">
                  <h3 className="pull-left">Interiør</h3>
                  <EquipmentFactoryList
                    equipmentFactory={this.props.equipmentFactory}
                    modelId={model.id}
                    customName="interiør"
                    noGroupCreate={true}
                    modelModified={this.props.modified}
                    onChange={this.handleEQFChange}
                  />
                </div>
              }
              {/* // EQUIMENT FACTORY */}

              {/* CONFIGURATOR */}
              <div role="tabpanel" className="tab-pane" id="configurator">
                <div className="row">
                  <div className="col-xs-12 col-md-6">

                    <div className="form-group">
                      <label>Standardkonfigurerering</label>
                      <input type="text" className="form-control" name="configurationId" value={model.configurationId} onChange={this.handleFieldChange} />
                      <span className="help-block">Verdien brukes til å laste konfigurering når brukeren første gang lander på konfiguratoren</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* // CONFIGURATOR */}

              {/* METADATA */}
              <div role="tabpanel" className="tab-pane" id="metadata">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <div className="form-group">
                      <div className="clearfix mf-margin-bottom-10">
                        <label>Metadata / OpenGraph</label>
                      </div>
                      {!this.props.modified && model.id &&
                        <Link
                          className="btn btn-default"
                          to={`/opengraph/new/model/${model.id}/${this.props.make.id}`}
                        >Opprett egendefinert metadata</Link>
                      }
                      {this.props.modified && <div className="alert alert-info">Du må lagre modellen før du kan gjøre endringer på metadata</div>}
                      <div className="mf-margin-top-10">
                        {this.props.opengraphs && this.props.opengraphs.map((og) => (
                          <Entity key={og.id} disabled={this.props.modified || this.props.working || model.archived} allowEdit={`/opengraph/model/${og.id}`} entity={og} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* // METADATA */}

            </div>
          </form>
        </section>
      );
    }
    return (
      <Loading title="Modell" text="Laster modelldata" />
    );
  }
}

Model.defaultProps = {
  model: null,
  variantGroups: null,
  modified: null,
  working: null,
  onChange: () => {},
  onSave: () => {},
  onPublish: () => {},
  onUnpublish: () => {}
};

export default Model;
